import { render, staticRenderFns } from "./formCapsule.vue?vue&type=template&id=4b463235&"
import script from "./formCapsule.vue?vue&type=script&lang=js&"
export * from "./formCapsule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b463235')) {
      api.createRecord('4b463235', component.options)
    } else {
      api.reload('4b463235', component.options)
    }
    module.hot.accept("./formCapsule.vue?vue&type=template&id=4b463235&", function () {
      api.rerender('4b463235', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/formCapsule.vue"
export default component.exports